import * as types from "../constants/actionConstants";


const initialState = {};

function categoryTemplateGraphReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_CATEGORY_GRAPH_SUCCESS:
            return {...action.categoryTemplateGraph};
        case types.CLEAR_CATEGORY_GRAPH:
            return {...initialState};
        default:
            return state;
    }
}

export default categoryTemplateGraphReducer;